import React, { useRef } from 'react';
import { CATEGORIES } from '../data/menuData';
import { useLanguage } from '../context/LanguageContext';
interface CategoryNavProps {
  activeCategory: string;
  onSelectCategory: (category: string) => void;
}
export function CategoryNav({
  activeCategory,
  onSelectCategory
}: CategoryNavProps) {
  const scrollRef = useRef<HTMLDivElement>(null);
  const {
    t,
    translateCategory
  } = useLanguage();
  const handleSelect = (category: string) => {
    onSelectCategory(category);
    // Scroll selected chip into view
    const el = scrollRef.current?.querySelector(`[data-cat="${category}"]`) as HTMLElement;
    if (el) {
      el.scrollIntoView({
        behavior: 'smooth',
        block: 'nearest',
        inline: 'center'
      });
    }
  };
  return <div className="sticky top-0 z-20 bg-carbon/95 backdrop-blur-sm py-2 px-4 -mx-4 mb-4" data-id="element-1056">
      <div ref={scrollRef} className="flex overflow-x-auto hide-scrollbar gap-2 pb-1" style={{
      touchAction: 'pan-x',
      WebkitOverflowScrolling: 'touch'
    }} data-id="element-1057">
        <button data-cat="Todos" onClick={() => handleSelect('Todos')} className={`whitespace-nowrap px-5 py-2.5 rounded-full text-sm font-medium transition-colors min-h-[44px] flex-shrink-0 ${activeCategory === 'Todos' ? 'bg-verde text-carbon shadow-md' : 'bg-surface text-gray-400 border border-gray-800'}`} data-id="element-1058">
          {t('all')}
        </button>
        {CATEGORIES.map(category => <button key={category} data-cat={category} onClick={() => handleSelect(category)} className={`whitespace-nowrap px-5 py-2.5 rounded-full text-sm font-medium transition-colors min-h-[44px] flex-shrink-0 ${activeCategory === category ? 'bg-verde text-carbon shadow-md' : 'bg-surface text-gray-400 border border-gray-800'}`} data-id="element-1059">
            {translateCategory(category)}
          </button>)}
      </div>
    </div>;
}